import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';
import { EmailThread } from '../models/email-thread.model';
import { AppConfigService } from './app-config.service';
import { EmailThreadDoc } from '../components/doc-viewer-new/doc-viewer-context-panel-template/email-threading-context-panel/email-thread-doc.model';

@Injectable({
  providedIn: 'root'
})
export class EmailThreadGroupingsService {

  constructor(private http: HttpClient, private appConfigService: AppConfigService, private errorHandler: ErrorHandlerService) { }

  getEmailThreads(emailThreadGroupId: string): Observable<EmailThread[]> {
    return this.http.get<EmailThread[]>(`${this.appConfigService.getConfig().webApi}/api2/EmailThreadGroupings/${emailThreadGroupId}/Threads`)
      .pipe(
        catchError(this.errorHandler.handleError<EmailThread[]>(`getEmailThreads with emailThreadId=${emailThreadGroupId}`))
      );
  }

  getEmailThreadDocs(emailThreadGroupId: string): Observable<EmailThreadDoc[]> {
    return this.http.get<EmailThreadDoc[]>(`${this.appConfigService.getConfig().webApi}/api2/EmailThreadGroupings/${emailThreadGroupId}/Docs`)
      .pipe(
        catchError(this.errorHandler.handleError<EmailThreadDoc[]>(`getEmailThreadDocs with emailThreadId=${emailThreadGroupId}`))
      );
  }

  getPrevThread(currentThreadId: string): Observable<string> {
    return this.http.get<string>(`${this.appConfigService.getConfig().webApi}/api2/EmailGroups/${currentThreadId}/Prev`)
      .pipe(catchError(this.errorHandler.handleError<string>(`get prev email thread`)));
  }

  getNextThread(currentThreadId: string): Observable<string> {
    return this.http.get<string>(`${this.appConfigService.getConfig().webApi}/api2/EmailGroups/${currentThreadId}/Next`)
      .pipe(catchError(this.errorHandler.handleError<string>(`get next email thread`)));
  }
}
